import axios from "axios";
import {
  RESPONSE_TYPES,
  STATUS_CODES,
  ERROR_CODES,
} from "@constants/response-types";
import { REFRESH_TOKEN_HEADER } from "@constants/auth";
import { SessionStorageService } from "../session-storage";
import { LocalStorageService } from "../local-storage";

const sessionStorageService = new SessionStorageService();
const localStorageService = new LocalStorageService();

axios.interceptors.request.use(
  async function (req) {
    return req;
  },
  function (error) {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  async (response) => {
    // Handle token refresh from server
    if (response.headers[REFRESH_TOKEN_HEADER]) {
      const newToken = response.headers[REFRESH_TOKEN_HEADER];
      try {
        // Get current role to update correct token
        const currentRole = sessionStorageService.getCurrentRole();

        if (currentRole) {
          // Update token for current role in localStorage
          await localStorageService.persistToken(currentRole, newToken);
          console.log("[Auth] Token refreshed for role:", currentRole);
        } else {
          // Fallback: update old authToken
          await localStorageService.persist("authToken", newToken);
          console.log("[Auth] Token refreshed (no role)");
        }
      } catch (error) {
        console.error("[Auth] Failed to update refresh token:", error);
      }
    }

    return response;
  },
  (error) => {
    if (
      axios.isCancel(error) ||
      error?.message === RESPONSE_TYPES.NETWORK_ERROR ||
      error?.response?.status === STATUS_CODES.REQUEST_TIMEOUT ||
      error?.code === ERROR_CODES.ECONNABORTED
    ) {
      return Promise.reject({ noInternet: true });
    }

    if (error?.response?.status === STATUS_CODES.UNAUTHORIZED) {
      setTimeout(() => {}, 4000);
    }

    return Promise.reject(error);
  }
);
